import React from 'react';
import { OrderInfo } from 'common/types';
import CompletedBookingsTableToolbar from './CompletedBookingsTableToolbar';
import BaseBookingsTable from './BaseBookingsTable';
import { BookingsTableRow } from './utils/rows';

interface CompletedBookingsTableProps {
	bookings: OrderInfo[];
	searchValue?: string;
	loading?: boolean;
}
const HIDDEN_COLUMNS: Array<keyof BookingsTableRow> = [
	'created',
	'preparationState',
	'deliveryOptionId',
];
const CompletedBookingsTable = (props: CompletedBookingsTableProps) => {
	return (
		<BaseBookingsTable
			{...props}
			Toolbar={CompletedBookingsTableToolbar}
			hiddenColumns={HIDDEN_COLUMNS}
			primaryDateColumn="completed"
		/>
	);
};

export default CompletedBookingsTable;
